<template>
    <div class="card card-with-shadow border-0 h-100">
        <div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">
            <h5 class="card-title text-capitalize mb-0">{{ $t('birthdays_of_the_month') }}</h5>
        </div>
        <div class="card-body position-relative p-0" :class="{'loading-opacity': preloader}">
            <app-overlay-loader v-if="preloader"/>
            <template v-else>
                <div v-if="employees.length === 0" class="text-center py-4 text-muted">
                    {{ $t('no_birthdays_this_month') }}
                </div>
                <div v-else class="birthday-list">
                    <table class="table table-hover mb-0">
                        <thead>
                            <tr>
                                <th class="border-top-0 pl-primary">{{ $t('profile') }}</th>
                                <th class="border-top-0 text-right pr-primary">{{ $t('day_month') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="employee in employees" :key="employee.id">
                                <td class="pl-primary">
                                    <div class="d-flex align-items-center">
                                        <div class="avatars-w-40 mr-2">
                                            <span v-if="!employee.profile_picture"
                                                  class="rounded-circle avatar-circle bg-brand-color"
                                                  :title="employee.full_name">
                                                {{ getInitials(employee) }}
                                            </span>
                                            <img v-else
                                                 :src="employee.profile_picture"
                                                 class="rounded-circle"
                                                 :alt="employee.full_name">
                                        </div>
                                        <div>
                                            <a :href="getProfileUrl(employee.id)" class="text-primary">
                                                {{ employee.full_name }}
                                            </a>
                                            <p class="text-muted mb-0 small">Dept: {{ employee.department }}</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="text-right pr-primary align-middle">
                                    {{ employee.day_month }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import {axiosGet} from "../../../../../common/Helper/AxiosHelper";
import {APP_DASHBOARD} from "../../../../Config/ApiUrl";
import {urlGenerator} from "../../../../../common/Helper/AxiosHelper";

export default {
    name: "BirthdaysOfMonth",
    data() {
        return {
            preloader: false,
            employees: []
        }
    },
    created() {
        this.getBirthdays();
    },
    methods: {
        getBirthdays() {
            this.preloader = true;
            axiosGet(`${APP_DASHBOARD}/birthdays`).then(({data}) => {
                this.employees = data.data || [];
                this.preloader = false;
            }).catch(() => {
                this.preloader = false;
            });
        },
        getInitials(employee) {
            const first = employee.first_name?.charAt(0)?.toUpperCase() || '';
            const last = employee.last_name?.charAt(0)?.toUpperCase() || '';
            return first + last;
        },
        getProfileUrl(id) {
            return urlGenerator(`/employees/${id}/profile`);
        }
    }
}
</script>

<style scoped>
.birthday-list {
    max-height: 400px;
    overflow-y: auto;
}
.avatar-circle {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
    color: white;
}
.avatars-w-40 img {
    width: 40px;
    height: 40px;
    object-fit: cover;
}
.bg-brand-color {
    background-color: #7c8a96;
}
</style>
